<script setup>
import { pageTransition } from '~/helpers/animations/animations';

const { t } = useI18n();

definePageMeta({
  pageTransition: pageTransition,
});
const pageQuery = gql`
  query GetPageData {
    page(id: 30) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      id
      breadcrumbs {
        name
        route_id
      }
      name
      perex
      content
    }
    events(filterCategory: "4", types: "event") {
      data {
        id
        name
        type
        categories {
          name
        }
        slug: seo_url_slug {
          cs
          en
        }
        image: image_list {
          url
          width
          height
        }
        imageCrop: image_list_crop_to
        buildings {
          id
          name
          seo_url_slug {
            cs
            en
          }
        }
        dates {
          id
          start_at {
            timestamp
          }
          end_at {
            timestamp
          }
          image_list
          image_detail
        }
      }
    }
  }
`;

const { clients } = useApollo();
const { locale } = useI18n();

const { data } = await useAsyncData(`education-talks-${locale.value}`, () =>
  clients.default.query({
    query: pageQuery,
    fetchPolicy: 'network-only',
  })
);

const page = computed(() => data.value?.data?.page);
const events = computed(() => data.value?.data?.events);
const content = computed(() => data.value?.data?.page.content);

const breadcrumbs = useBreadCrumbs(data.value?.data?.page.breadcrumbs || []);

const perex = computed(() => [
  {
    type: 'perex',
    data: {
      text: page.value?.perex,
    },
  },
]);

useHead({
  title: page.value ? (page.value?.seo_meta_title ? page.value?.seo_meta_title : page.value?.name) : null,
  description: page.value && page.value?.seo_meta_description ? page.value?.seo_meta_description : null,
  keywords: page.value && page.value?.seo_meta_keywords ? page.value?.seo_meta_keywords : null,
});
</script>

<template>
  <main class="main">
    <div v-if="page">
      <Breadcrumbs :items="breadcrumbs" />
      <h1 class="heading">{{ page.name }}</h1>
      <DynamicPageContent :content="perex" class="mt-3" />
      <DynamicPageContent :content="content" class="mt-5" />
      <div v-if="events.data.length">
        <h2 class="heading heading--2 heading--thin mt-5">
          {{ t('global.choose-an-event') }}
        </h2>
        <EventGrid :data="events.data" class="mt-4" hide-type />
      </div>
    </div>
  </main>
</template>
